// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2ERzs","col":"styles_col__bZ-fW"};